(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cda-try-it-out"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const flipButton = document.getElementById('flip-button');
  const generateResultButton = document.getElementById('generate-result');
  const resultButtonContainer = document.getElementById('result-button-container');
  const resultImageContainer = document.getElementById('result-image-container');
  const resultImage = document.getElementById('result-image');
  const cards = document.querySelectorAll('.card-how');

  let flipping = false;
  let currentCombo = null;
  let usedImages = {};
  let lastShownImage = null;
  let isDefaultState = true;
  let hasClickedResult = false;

  const defaultBacks = window.cdaTryItOutData.default_backs;
  const combinations = window.cdaTryItOutData.combinations;
  const resultButtonTextAfter = "Click Again to see More!";

  function setCardsToDefault() {
    cards.forEach((card, i) => {
      card.classList.remove('flipped');
      card.classList.add('unflipping');
      setTimeout(() => {
        card.classList.remove('unflipping');
        card.querySelector('.card-back-how').src = defaultBacks[i];
        card.querySelector('.card-front-how').src = '';
      }, 500);
    });
    resultImageContainer.style.display = 'none';
    resultButtonContainer.classList.remove('animate-in');
    resultButtonContainer.classList.add('animate-out');
    lastShownImage = null;
    generateResultButton.classList.remove('glow');
    generateResultButton.textContent = "See how others did";
    hasClickedResult = false;
  }

  function showNewCombination() {
    currentCombo = Math.floor(Math.random() * combinations.length);
    usedImages[currentCombo] = [];
    const combo = combinations[currentCombo];

    cards.forEach((card, i) => {
      const frontImg = card.querySelector('.card-front-how');
      frontImg.src = combo.fronts[i];

      setTimeout(() => {
        card.classList.add('flipped');
        if (i === cards.length - 1) {
          setTimeout(() => {
            resultButtonContainer.classList.remove('animate-out');
            resultButtonContainer.classList.add('animate-in');
          }, 500);
        }
      }, 300 * i);
    });
  }

  flipButton.addEventListener('click', () => {
    if (flipping) return;
    flipping = true;

    if (isDefaultState) {
      showNewCombination();
    } else {
      setCardsToDefault();
    }

    isDefaultState = !isDefaultState;
    setTimeout(() => { flipping = false; }, 1000);
  });

  generateResultButton.addEventListener('click', () => {
    const pool = combinations[currentCombo].results;
    let available = pool.filter(img => !usedImages[currentCombo].includes(img) && img !== lastShownImage);

    if (available.length === 0) {
      usedImages[currentCombo] = [];
      available = [...pool];
    }

    const randomImage = available[Math.floor(Math.random() * available.length)];
    usedImages[currentCombo].push(randomImage);
    lastShownImage = randomImage;

    resultImage.style.animation = 'none';
    resultImage.offsetHeight;
    resultImage.style.animation = null;
    resultImage.src = randomImage;
    resultImageContainer.style.display = 'block';

    setTimeout(() => {
      resultButtonContainer.scrollIntoView({ behavior: 'smooth' });
    }, 300);

    if (!hasClickedResult) {
      generateResultButton.classList.add('glow');
      generateResultButton.textContent = resultButtonTextAfter;
      hasClickedResult = true;
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
